export const convertFilterName = (label: string): string => {
  const gradeMatch = label.match(/^Grade (\d+)$/);
  if (gradeMatch?.[1]) {
    const grade = parseInt(gradeMatch[1], 10);
    switch (grade) {
      case 1:
        return "1st";
      case 2:
        return "2nd";
      case 3:
        return "3rd";
      default:
        return `${grade}th`;
    }
  }
  return label === "Kindergarten" ? "K" : label[0]?.toUpperCase() || "";
};
